import * as React from "react";
import Dots from "./Dots";

interface LoaderProps {
	isLoading: boolean;
	children: React.ReactNode;
}

function Preloader({ children, isLoading }: LoaderProps) {
	if (isLoading) {
		return (
			<div className="preloader">
				<Dots />
			</div>
		);
	}
	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{children}</>;
}

export default Preloader;
